import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { PLAN_REVIEW_COPY } from '@personal-trainer-app/shared/src/utils/questionnaire/questionnaire-form';

import { Alert } from '@/components/ui';

/**
 * The notice that arrives with the injury switch: a plan built around an
 * injury is checked by one of the team before it is released, so it will not
 * be ready the moment the form is sent.
 *
 * An `info` alert, not a warning — nothing is at risk; an expectation is being
 * set, before the user has typed anything rather than after they have finished.
 * Shared by the questionnaire's Watch-outs step and the refine form.
 */
export function PlanReviewNotice(): React.JSX.Element {
  return (
    <Alert
      variant="info"
      title={PLAN_REVIEW_COPY.noticeTitle}
      icon={<ShieldCheckIcon />}
      data-testid="plan-review-notice"
    >
      {PLAN_REVIEW_COPY.noticeBody}
    </Alert>
  );
}

export default PlanReviewNotice;
